import Footer from "../../components/Footer";
import PG_1 from "../../assets/img/pg_1.png";
import MED_1 from "../../assets/img/med_1.png";
import MED_2 from "../../assets/img/med_2.png";
import PG_2 from "../../assets/img/pg_2.png";
import PG_3 from "../../assets/img/pg_3.png";
import "../style.css";
import { useParams } from "react-router-dom";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
export default function MedicalSchoolSupport() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "Medical School Support",
      desc: "The Medicine Service covers applications for medicine, dentistry, and veterinary studies, some of the toughest courses to secure a place in the Global.",
      img: MED_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for applying to the Global top universities",
      desc: "The Global boasts some of the world’s most prestigious medical schools, renowned for their rigorous programmes that integrate academic study, clinical practice, and research opportunities. Admission to these institutions is highly competitive, with strict entry requirements, limited places, and demanding selection processes. Success requires meticulous planning – from choosing the right medical school to crafting a standout application. Global StudyIn’s Medicine Application Service provides comprehensive support to maximise your chances of securing a place at your preferred institution. Our specialists guide you through every stage, from initial eligibility assessment to intensive interview preparation, ensuring you receive expert assistance throughout this critical process.",
    },
    thirdSection: {
      rightSection: {
        img: MED_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Medicine Service will offer the following to maximise your chance of securing an offer:",
      },
      leftColumnContent: [
        {
          title: "Advice",
          description:
            "We help you research best-fit medicine programmes and choose courses that match your interests",
        },
        {
          title: "Document checklist",
          description:
            "We will review your transcripts, qualifications, and academic background to confirm your eligibility to your preferred university and course",
        },
        {
          title: "Personal statement advice",
          description:
            "We help you put together the documents required by universities for entry",
        },
        {
          title: "Additional requirements",
          description:
            "We ensure you meet all deadlines for additional medical course requirements, such as the University Clinical Aptitude Test (UCAT)",
        },
        {
          title: "Interview practice",
          description:
            "We host a 60-minute interview practice session with a practising surgeon who sits on the admissions panel of a London medical school",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Medical School Support",
      desc: "The Medicine Service covers applications for medicine, dentistry, and veterinary studies, some of the toughest courses to secure a place in the Global.",
      img: MED_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for applying to the Global top universities",
      desc: "The Global boasts some of the world’s most prestigious medical schools, renowned for their rigorous programmes that integrate academic study, clinical practice, and research opportunities. Admission to these institutions is highly competitive, with strict entry requirements, limited places, and demanding selection processes. Success requires meticulous planning – from choosing the right medical school to crafting a standout application.Global StudyIn’s Medicine Application Service provides comprehensive support to maximise your chances of securing a place at your preferred institution. Our specialists guide you through every stage, from initial eligibility assessment to intensive interview preparation, ensuring you receive expert assistance throughout this critical process.",
    },
    thirdSection: {
      rightSection: {
        img: MED_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Medicine Service will offer the following to maximise your chance of securing an offer:",
      },
      leftColumnContent: [
        {
          title: "Advice",
          description:
            "We help you research best-fit medicine programmes and choose courses that match your interests",
        },
        {
          title: "Document checklist",
          description:
            "We will review your transcripts, qualifications, and academic background to confirm your eligibility to your preferred university and course",
        },
        {
          title: "Personal statement advice",
          description:
            "We help you put together the documents required by universities for entry",
        },
        {
          title: "Additional requirements",
          description:
            "We ensure you meet all deadlines for additional medical course requirements, such as the University Clinical Aptitude Test (UCAT)",
        },
        {
          title: "Interview practice",
          description:
            "We host a 60-minute interview practice session with a practising surgeon who sits on the admissions panel of a London medical school",
        },
      ],
      rightColumnContent: [],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };
  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;

  return (
    <div className="personalised-guidance medical-school-support">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
